import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white mt-12">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="border-t border-gray-200 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-wrap gap-x-6 gap-y-4">
              <a href="https://proxyscrape.com/terms-and-conditions" className="text-sm text-gray-500 hover:text-gray-700">
                Terms & Conditions
              </a>
              <a href="https://proxyscrape.com/privacy-policy" className="text-sm text-gray-500 hover:text-gray-700">
                Privacy Policy
              </a>
              <a href="https://proxyscrape.com/cookie-policy" className="text-sm text-gray-500 hover:text-gray-700">
                Cookie Policy
              </a>
              <a href="https://proxyscrape.com/disclaimer" className="text-sm text-gray-500 hover:text-gray-700">
                Disclaimer
              </a>
            </div>
            <div className="text-sm text-gray-500">
              © Copyright {currentYear} - Thib BV<br />
              <address className="not-italic">
                Brugstraat 18<br />
                2812 Mechelen<br />
                Belgium<br />
                VAT BE 0749 716 760
              </address>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}